// extracted by mini-css-extract-plugin
export default {"activtyPage_container":"sensorEntity_activtyPage_container__mREnT","container":"sensorEntity_container__pZDn1"};